import { render, staticRenderFns } from "./bsj-set-max-speed-sms-modal.vue?vue&type=template&id=6298f15b"
import script from "./bsj-set-max-speed-sms-modal.vue?vue&type=script&lang=js"
export * from "./bsj-set-max-speed-sms-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports